import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { withAccessDenied, withNotifications, withRouter } from '@app/hocs'
import { withStyles } from '@app/components/styles'
import isAccessTokenValid from '@app/helpers/isAccessTokenValid'
import isUserLoggedIn from '@app/helpers/isUserLoggedIn'
import * as syncNotifications from '@app/actions/notifications/notificationsChannel'
import { isIOS } from 'react-device-detect'
import SelectMultichannelActionSubDeviceValue
  from '@app/components/MyAutomation/Tabs/ScenesScreens/CreateAction/ZwaveMultichannelAction/SelectMultichannelActionSubDeviceValue/SelectMultichannelActionSubDeviceValue'
import SelectMultichannelActionSubDeviceValueIOS
  from '@app/components/MyAutomation/Tabs/iOS/CreateAction/ZwaveMultichannelAction/SelectMultichannelActionSubDeviceValue/SelectMultichannelActionSubDeviceValue'
import {
  saveActionStateDescription,
  saveActionDuration,
  saveActionDurationDescription,
  saveActionDurationValueAfter,
} from '@app/actions/scenes/currentSceneCreating'

const isWebView = navigator.userAgent.includes('WebView') || navigator.userAgent.includes('wv')
let enhance = isIOS && isWebView
  ? withStyles(SelectMultichannelActionSubDeviceValueIOS) : withStyles(SelectMultichannelActionSubDeviceValue)

const mapStateToProps = (state) => {
  const { isMobile } = state.mobileDetector
  const { path } = state.shadowIn
  const { stateDescription } = state.scenes.currentSceneCreating.currentAction
  return {
    isMobile,
    path,
    stateDescription,
    accessDenied: !isAccessTokenValid(state.secrets.accessToken),
    userLoggedIn: (isUserLoggedIn(state.users.currentUser.user.preferredName)),
  }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  notifications: syncNotifications.sync,
  saveActionStateDescription,
  saveActionDuration,
  saveActionDurationDescription,
  saveActionDurationValueAfter,
}, dispatch)

enhance = withAccessDenied(enhance)
enhance = withNotifications(enhance)
enhance = connect(mapStateToProps, mapDispatchToProps)(enhance)

const SelectMultichannelActionSubDeviceValueEnhanced = enhance

export default withRouter(SelectMultichannelActionSubDeviceValueEnhanced)
